module.exports = __webpack_public_path__ + "static/media/pcffa.b0e84c78.webp";